const AD_ADMIN_DROPDOWN_OPTIONS = ['전체 광고', '진행중', '중단됨'];

const AD_ITEM_DESC = ['상태', '광고 생성일', '일 희망 예산', '광고 수익률', '매출', '광고 비용'];

const AD_STATUS = { active: '진행중', ended: '중단됨' };

const AD_SORT = { web: '웹광고', app: '앱광고' };

export { AD_ADMIN_DROPDOWN_OPTIONS, AD_ITEM_DESC, AD_STATUS, AD_SORT };
